module.exports = __webpack_public_path__ + "assets/images/pages/ebaysocial/ebaysocial-2.png?4d35b393";